import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

// import { replaceVariableByValue } from 'utils/getVariables'
// import { GTMLogEvent } from '../../utils/gtm'
import { ExternalLink } from './styles'

const CustomLink = React.forwardRef(({ to = '', children, ...props }, ref) => {
    const external = to.startsWith('http') === true
    const logEventClique = useCallback(
        (eventLabel) => {
            if (eventLabel) {
                /* GTMLogEvent(
                    'event',
                    'veloe:geral',
                    `clique:${parentComponent}`,
                    eventLabel
                ) */
                props.onClick && props.onClick()
            }
        },
        [props]
    )

    return (
        <>
            {external ? (
                <ExternalLink
                    {...props}
                    ref={ref}
                    onClick={() => logEventClique(props.tagLabel)}
                    href={to}
                >
                    {children}
                </ExternalLink>
            ) : (
                // <a href={to}>
                <ExternalLink
                    {...props}
                    ref={ref}
                    onClick={() => logEventClique(props.tagLabel)}
                    onKeyPress={() => logEventClique(props.tagLabel)}
                    tabIndex={props.tabIndex}
                    role="link"
                    href={to}
                >
                    {children}
                </ExternalLink>
                // </a>
            )}
        </>
    )
})

CustomLink.propTypes = {
    children: PropTypes.any,
    external: PropTypes.bool,
    to: PropTypes.string,
    parentComponent: PropTypes.string,
    tabIndex: PropTypes.number,
    tagLabel: PropTypes.string,
}

CustomLink.defaultProps = {
    children: undefined,
    external: false,
    to: undefined,
    parentComponent: 'footer',
    tabIndex: 0,
    tagLabel: undefined,
}

export default CustomLink
